<template>
    <div class="content-line" ref="line">
        <div class="content-line-inner">
            <component :is="getComponent" :content="content"/>
        </div>
        <div class="read-mode" @click="openLine">Weiterlesen...</div>
    </div>
</template>

<script>
import Text from "@/components/elements/Text.vue";
import Bild from "@/components/elements/Bild.vue";
import TextZeile from "@/components/elements/TextZeile.vue";
import BildZeile from "@/components/elements/BildZeile.vue";
import TextBildZeile from "@/components/elements/TextBildZeile.vue";
import GenerierterInhalt from "@/components/elements/GenerierterInhalt.vue";

export default {
    data() {
        return {};
    },
    props: [
        "content",
    ],
    computed: {
        getComponent() {
            switch (this.content.__component) {
                case 'inhaltsblock.test-bild-zeile':
                    return TextBildZeile;
                case 'inhaltsblock.test1':
                    return BildZeile;
                case 'inhaltsblock.mehrere-texte':
                    return TextZeile;
                case 'inhaltsblock.bild':
                    return Bild;
                case 'inhaltsblock.test':
                    return Text;
                case 'inhaltsblock.generierter-inhalt':
                    return GenerierterInhalt;
            }
        },
    },
    methods: {
        openLine() {
            const line = this.$refs.line;
            const oldHeight = line.clientHeight + "px";
            line.style.height = "auto";
            const height = line.clientHeight + "px";
            line.style.height = oldHeight;
            setTimeout(() => {
                line.style.height = height;
            }, 0);
            setTimeout(() => {
                line.style.height = 'auto';
            }, 500);
            line.classList.add("faded");
        }
    }
}
</script>